import { CustomRoute } from "@/interfaces";
import { AppWindowMac, Bell, CreditCard, FilePlus2, FileText, FolderKanban, History, LayoutDashboard, Repeat, Settings, Star, Users } from "lucide-react";
import React from "react";

const Dashboard = React.lazy(() => import("../modules/Client/Dashboard"));
const MyServices = React.lazy(() => import("../modules/Client/MyServices"));
const MyTeam = React.lazy(() => import("../modules/Client/Team"));
const PaymentHistory = React.lazy(() => import("../modules/Client/PaymentHistory"));
const MyInvoices = React.lazy(() => import("../modules/Client/Invoices"));
const AllNotifications = React.lazy(() => import("../modules/Notifications/AllNotifications"));
const ServiceRating = React.lazy(() => import("../modules/Client/ServicesRatingManagement"));
const EditProfile = React.lazy(() => import("../modules/Profile/EditProfile"));
const ClientTeamworkProjects = React.lazy(() => import("../modules/Client/ClientTeamworkProjects/index"));
const CreateEditBill = React.lazy(() => import("../modules/Client/CreateEditBill"));
const AllBills = React.lazy(() => import("../modules/Client/AllBills"));
const RecurringTransactions = React.lazy(() => import("../modules/Client/Invoices/RecurringTransactions"));
const AutoDebitSettings = React.lazy(() => import("../modules/Client/AutoDebitSettings"));

const clientRoutes: CustomRoute[] = [
  {
    path: "/",
    id: "Client",
    element: <Dashboard />,
    menuName: "Dashboard",
    icon: LayoutDashboard,
    highlightOn: ["dashboard"],
  },
  {
    path: "/my-services",
    id: "Client",
    element: <MyServices />,
    menuName: "My Services",
    icon: Settings,
    highlightOn: ["my-services"],
  },
  {
    path: "/my-team",
    id: "Client",
    element: <MyTeam />,
    menuName: "My Team",
    icon: Users,
    highlightOn: ["my-team"],
  },
  {
    path: "/teamwork-projects",
    id: "Client",
    element: <ClientTeamworkProjects />,
    menuName: "Teamwork Projects",
    icon: FolderKanban,
    highlightOn: ["teamwork-projects"],
  },
  {
    path: "",
    id: "Admin",
    element: null,
    menuName: "Financials",
    icon: AppWindowMac,
    highlightOn: ["billing", "invoices"],
    submenu: [
      {
        path: "/payment-history",
        id: "Client",
        element: <PaymentHistory />,
        menuName: "Payment History",
        icon: History,
        highlightOn: ["payment-history"],
      },
      {
        path: "/payment-settings",
        id: "Client",
        element: <AutoDebitSettings />,
        menuName: "Payment Settings",
        icon: CreditCard,
        highlightOn: ["payment-settings"],
      },
      {
        path: "/invoices",
        id: "Client",
        element: <MyInvoices />,
        menuName: "All Invoices",
        icon: FileText,
        highlightOn: ["invoices"],
      },
      {
        path: "/recurring-invoices",
        id: "Client",
        element: <RecurringTransactions />,
        menuName: "Recurring Invoices",
        icon: Repeat,
        highlightOn: ["recurring-invoices"],
      },
      {
        path: "/bills",
        id: "Client",
        element: <AllBills />,
        menuName: "All Bills",
        icon: FileText,
        highlightOn: ["bills"],
      },
      {
        path: "/create-bill",
        id: "Client",
        element: <CreateEditBill />,
        menuName: "Create Bill",
        icon: FilePlus2,
        highlightOn: ["create-bill"],
      },
    ],
  },
  {
    path: "/notifications",
    id: "Client",
    element: <AllNotifications />,
    menuName: "Notifications",
    icon: Bell,
    highlightOn: ["notifications"],
  },
  {
    path: "/service-rating",
    id: "Client",
    element: <ServiceRating />,
    menuName: "Rate Services",
    icon: Star,
    highlightOn: ["service-rating"],
  },
  {
    path: "/profile",
    id: "Client",
    element: <EditProfile />,
    menuName: "Profile",
    icon: Users,
    highlightOn: ["profile"],
  },
];

export default clientRoutes;
